module.exports = __webpack_public_path__ + "static/media/arrow-right-white.03c95621.svg";